// extracted by mini-css-extract-plugin
export var arrowUpAndDown = "Menu-module--arrow-up-and-down--d7ae2";
export var container = "Menu-module--container--2f0b8";